module.exports = __webpack_public_path__ + "static/media/quote-right.03751991.svg";